<template>
    <div class="ticket-layout">
        <div
            v-if="permission === 'INITIAL'"
            v-loading.fullscreen="permission === 'INITIAL'"
        ></div>
        <NoAccess v-else-if="permission === null"/>
        <router-view v-else/>
    </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {useStore} from '@/store/useStore';
import NoAccess from './NoAccess.vue';

const store = useStore();
const permission = computed(() => store.getters.userInfo.permission);
</script>
